import { render, staticRenderFns } from "./sectionButton.vue?vue&type=template&id=36cec9a4&scoped=true"
import script from "./sectionButton.vue?vue&type=script&lang=js"
export * from "./sectionButton.vue?vue&type=script&lang=js"
import style0 from "./sectionButton.vue?vue&type=style&index=0&id=36cec9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cec9a4",
  null
  
)

export default component.exports